/* PROJ-110 (12.10.2026): Streichpreis + Sale-Farbe im Editor-Preisblock.
   Quelle der Varianten: <script id="dm-editor-varianten"> aus snippets/editor-streichpreis.liquid.
   Aktuelle Variante: siehe aktuelleVariante() (data-variant-id, Preis-Text, hidden input, Standard).
   Preis-Element: .desc > .include > .variant-price (Poster unter .bottom__controls, Schmuck unter .elem__picker).
   Auslöser: jede Änderung am .variant-price (Text oder Attribute) — jeder Editor schreibt dort
   beim Varianten-Wechsel den Preis neu. Preis-Text selbst bleibt unangetastet. */
(function () {
  'use strict';

  var datenEl = document.getElementById('dm-editor-varianten');
  if (!datenEl) return;
  var varianten;
  try { varianten = JSON.parse(datenEl.textContent); } catch (fehler) { return; }
  var standardId = datenEl.getAttribute('data-standard') || '';

  /* Inline-Stil identisch zum Liquid-Streichpreis in den Sections, damit erzeugte und gerenderte Spans gleich aussehen. */
  var STREICH_STIL = 'text-decoration: line-through; color: #999; margin-left: 8px;';

  function preisElement() {
    /* Poster-Editoren: .bottom__controls > .desc > .include; Schmuck-Editoren (jewelry*.liquid): .elem__picker > .desc > .include.
       Gemeinsam ist beiden die Kette .desc > .include > .variant-price. */
    return document.querySelector('.desc > .include > .variant-price');
  }

  function centsAusText(text) {
    var treffer = /(\d+)[,.](\d{2})/.exec(text || '');
    return treffer ? parseInt(treffer[1], 10) * 100 + parseInt(treffer[2], 10) : null;
  }

  /* Reihenfolge der Quellen:
     1. data-variant-id am Preis (Schmuck-Editoren setzen es in wechsleFarbe).
     2. Der gerade geschriebene Preis-Text: eindeutig einer Variante zuzuordnen, oder alle Treffer
        haben denselben Streichpreis. Noetig, weil die Mama-Poster-Editoren (definitionsposter.js,
        familie.js, …) das hidden input[name="id"] erst beim Warenkorb-Klick aus der Kachel lesen —
        waehrend der Auswahl steht dort noch die erste Variante.
     3. Hidden input[name="id"] (Stadtkarte, Sternkarte, Fotoposter pflegen es sofort).
     4. data-standard des JSON-Blocks (Startzustand). */
  function aktuelleVariante(preis) {
    var attr = preis.getAttribute('data-variant-id');
    if (attr && varianten[attr]) return varianten[attr];

    var cents = centsAusText(preis.textContent);
    if (cents !== null) {
      var treffer = [];
      Object.keys(varianten).forEach(function (id) { if (varianten[id].preis === cents) treffer.push(varianten[id]); });
      if (treffer.length === 1) return treffer[0];
      if (treffer.length > 1 && treffer.every(function (v) { return v.streich === treffer[0].streich; })) return treffer[0];
    }

    var input = document.querySelector('.bottom__controls input[name="id"]')
      || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && varianten[input.value]) return varianten[input.value];
    return varianten[standardId] || null;
  }

  function formatiere(cents, vorlage) {
    var betrag = (cents / 100).toFixed(2).replace('.', ',');
    var trenner = vorlage.indexOf(' ') !== -1 ? ' ' : ' ';
    return betrag + trenner + '€';
  }

  function aktualisiere() {
    var preis = preisElement();
    if (!preis) return;
    var variante = aktuelleVariante(preis);
    if (!variante) return;
    var include = preis.parentNode;
    var streich = include.querySelector('.variant-compare-price');
    var badge = include.parentNode.querySelector('.save');
    var imSale = variante.streich && variante.streich > variante.preis;

    if (imSale) {
      if (!streich) {
        streich = document.createElement('span');
        streich.className = 'variant-compare-price';
        streich.setAttribute('style', STREICH_STIL);
        preis.insertAdjacentElement('afterend', streich);
      }
      var streichText = formatiere(variante.streich, preis.textContent);
      if (streich.textContent !== streichText) streich.textContent = streichText;
      streich.setAttribute('data-compare-price', String(variante.streich));
      if (!preis.classList.contains('ist-sale')) preis.classList.add('ist-sale');
      if (badge) {
        var prozent = Math.round((variante.streich - variante.preis) * 100 / variante.streich);
        badge.textContent = badge.textContent.replace(/\d+/, String(prozent));
        badge.setAttribute('data-savings', String(variante.streich - variante.preis));
        badge.setAttribute('data-savings-percent', String(prozent));
        badge.hidden = false;
      }
    } else {
      if (streich) streich.parentNode.removeChild(streich);
      if (preis.classList.contains('ist-sale')) preis.classList.remove('ist-sale');
      if (badge) badge.hidden = true;
    }
  }

  /* Direkt im Observer-Callback nachziehen (Mutationen kommen gesammelt als Microtask, also nach dem
     synchronen Editor-Code inklusive setAttribute). Bewusst KEIN Animation-Frame: der pausiert in
     Hintergrund-Tabs und liess den Streichpreis stehen. Die eigenen Schreibzugriffe liegen ausserhalb
     des beobachteten Knotens; die Klasse ist-sale wird nur bei echter Aenderung gesetzt und steht nicht im
     attributeFilter. Sonst ergibt Klasse setzen -> Mutation -> Callback -> Klasse setzen eine endlose
     Microtask-Kette, die den Tab einfriert (passiert 12.10. 01:50 auf Dev). */
  var laeuft = false;
  function beiMutation() {
    if (laeuft) return;
    laeuft = true;
    try { aktualisiere(); } finally { laeuft = false; }
  }

  function start() {
    var preis = preisElement();
    if (!preis) return;
    aktualisiere();
    new MutationObserver(beiMutation).observe(preis, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-price'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
